import "../../helpers/secondarycss.css";
import { Link } from "react-router-dom";
import { Theme } from "../../data/style/Theme";
import * as routes from "../../data/links/routes";
import useScreenSize from "../../context/ScreenContext";
import { lazy, Suspense, useEffect, useState } from "react";
import tikTokIcon from "../../data/images/icons8-tiktok.svg";
import tikTokIconWhite from "../../data/images/icons8-tiktok_white.svg";
import {
  SpacedRow,
  FormButton,
  CenteredRow,
  MainTitle,
  AllCenteredColumn,
} from "../../data/style/Style";

const Box = lazy(() => import("@mui/material/Box"));
const Stack = lazy(() => import("@mui/material/Stack"));
const marqueeQuotes = [
  "EMBRACE THE GRIND",
  "EVERY REP COUNTS",
  "EARN YOUR RESULTS",
  "ONE MORE REP",
  "FOREVER PACE",
];
const RegisterModal = lazy(() => import("../Modals/RegisterModal"));
const FacebookIcon = lazy(() => import("@mui/icons-material/Facebook"));
const InstagramIcon = lazy(() => import("@mui/icons-material/Instagram"));

const Header = () => {
  const { size, mobileDevice } = useScreenSize();
  const [tiktokHovered, setTikTokHovered] = useState(false);
  var [width] = size;
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const HeaderIconClass = {
    cursor: "pointer",
    fontSize: mobileDevice || width < 750 ? "1rem" : "1.2rem",
    "&:hover": { color: "white" },
  };

  return (
    <SpacedRow
      alignItems={"center"}
      height={"10vh"}
      minHeight={"50px"}
      width={"100%"}
      sx={{
        zIndex: 1000,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        background: scrolled ? Theme.palette.surface : "transparent",
        backdropFilter: scrolled ? "blur(16px)" : "none",
        borderBottom: scrolled
          ? `1px solid ${Theme.palette.border}`
          : "1px solid transparent",
        transition: "all .35s ease",
      }}
    >
      <MainTitle
        ml={width < 600 ? 1 : 3}
        fontSize={width < 600 ? "1rem" : "1.7rem"}
      >
        GRIND <span style={{ color: Theme.palette.orange }}>PARTNER</span>
      </MainTitle>
      {!mobileDevice && width >= 850 && (
        <Box
          className="marquee-wrapper"
          sx={{ flex: 1, mx: 4, height: "1.4rem" }}
        >
          <Stack direction="row" className="marquee-track">
            <MarqueeContent />
            <MarqueeContent />
          </Stack>
        </Box>
      )}
      <CenteredRow p={1} gap={mobileDevice || width < 600 ? 0.5 : 1.5}>
        <SocialIcon
          link={process.env.REACT_APP_FACEBOOK_URL}
          icon={
            <FacebookIcon
              sx={{ ...HeaderIconClass, color: Theme.palette.blue }}
            />
          }
        />
        <SocialIcon
          link={process.env.REACT_APP_INSTAGRAM_URL}
          icon={
            <InstagramIcon
              sx={{ ...HeaderIconClass, color: Theme.palette.purple }}
            />
          }
        />
        <a
          onMouseOver={() => setTikTokHovered(true)}
          onMouseOut={() => setTikTokHovered(false)}
          href={process.env.REACT_APP_TIKTOK_URL}
          rel="noreferrer"
          target="_blank"
        >
          <AllCenteredColumn
            p={1}
            sx={{
              border: 1,
              borderRadius: 2,
              borderColor: Theme.palette.border,
              background: Theme.palette.card,
            }}
          >
            {tiktokHovered ? (
              <img src={tikTokIconWhite} alt="Tik Tok" width={20} height={20} />
            ) : (
              <img src={tikTokIcon} alt="Tik Tok" width={20} height={20} />
            )}
          </AllCenteredColumn>
        </a>
        <Link style={{ textDecoration: "none" }} to={routes.LOGIN}>
          <FormButton mobile={mobileDevice} alt={true} small={true}>
            Log in
          </FormButton>
        </Link>
        <Box mr={1}>
          <Suspense>
            <RegisterModal />
          </Suspense>
        </Box>
      </CenteredRow>
    </SpacedRow>
  );
};

export default Header;

const MarqueeContent = () => (
  <>
    {marqueeQuotes.map((quote, index) => (
      <Box
        key={index}
        component="span"
        sx={{
          whiteSpace: "nowrap",
          fontFamily: "Oswald, sans-serif",
          letterSpacing: "0.08em",
          fontSize: "0.85rem",
          color: Theme.palette.textSub,
          mr: 5,
        }}
      >
        {quote}{" "}
        <Box component="span" sx={{ color: Theme.palette.orange }}>
          •
        </Box>
      </Box>
    ))}
  </>
);

const SocialIcon = ({ icon, link }) => {
  return (
    <a href={link} rel="noreferrer" target="_blank">
      <AllCenteredColumn
        p={1}
        sx={{
          border: 1,
          borderRadius: 2,
          borderColor: Theme.palette.border,
          background: Theme.palette.card,
        }}
      >
        {icon}
      </AllCenteredColumn>
    </a>
  );
};
